import { ArrowForward } from '@mui/icons-material';
import React from 'react';

import CButton from './CButton';
import CLocalizedText from './CLocalizedText';
import CLocalizedTextStringStatic from './CLocalizedTextStringStatic';
import CPageModule from './CPageModule';
import Page from './layout/Page';

interface Props {
  heading?: React.ReactNode;
  description?: React.ReactNode;
  redirectURL: string;
}

export default function CRequestSuccessPage(props: Props) {
  const returnToHomepage = CLocalizedTextStringStatic('global.returnToHomepage');
  const returnToPortal = CLocalizedTextStringStatic('global.returnToPortalHome');
  return (
    <Page>
      <CPageModule>
        <h2>{props.heading ?? <CLocalizedText dictKey={'global.formSubmission.success.heading'} />}</h2>
        <p>{props.description ?? <CLocalizedText dictKey={'global.formSubmission.success.description'} />}</p>
        <div>
          <a href={props.redirectURL}>
            <CButton isForm icons={{ end: <ArrowForward /> }} style={{ borderWidth: '1px' }} onClick={() => {}}>
              {props.redirectURL === '/' ? returnToPortal : returnToHomepage}
            </CButton>
          </a>
        </div>
      </CPageModule>
    </Page>
  );
}
